/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown>, amount: NonNullable<unknown> }} Seat_Price_Monthly_UpInputs */



/**
* | output |
* | --- |
* | "From {date}, your monthly bill goes up by {amount} (excl. VAT)." |
*
* @param {Seat_Price_Monthly_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_price_monthly_up = /** @type {((inputs: Seat_Price_Monthly_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Price_Monthly_UpInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Ab ${i?.date} steigt Ihre Monatsrechnung um ${i?.amount} (zzgl. MwSt.).`)
	return /** @type {LocalizedString} */ (`From ${i?.date}, your monthly bill goes up by ${i?.amount} (excl. VAT).`)
});